import { render, staticRenderFns } from "./BaseChecklistSkeleton.vue?vue&type=template&id=13102755"
import script from "./BaseChecklistSkeleton.vue?vue&type=script&lang=js"
export * from "./BaseChecklistSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports